import { z } from 'zod/v4';

export const ListDataPointAnswersParamsSchema = z.object({
  forCompanyId: z.string().min(1),
});

export type ListDataPointAnswersParams = z.infer<
  typeof ListDataPointAnswersParamsSchema
>;

export const ListDataPointAnswersQuerySchema = z.object({
  page: z.coerce.number().int().min(0).default(0),
  count: z.coerce.number().int().min(0).max(500).default(15),
  sort: z
    .string()
    .regex(/^name:(ASC|DESC)$/)
    .optional(),
  filter: z.string().max(512).optional(),
  onBehalfOfCompanyId: z.string().max(512).optional(),
  sectionId: z.string().max(512).optional(),
});

export type ListDataPointAnswersQuery = z.infer<
  typeof ListDataPointAnswersQuerySchema
>;

// Rows come from an external, richly-shaped data-point-definition library
// (dozens of fields beyond retracedId/name), merged with a subset of any
// persisted answer (value/unit/year) — loose to avoid re-declaring that shape.
export const DataPointAnswerListRowSchema = z.looseObject({
  retracedId: z.string(),
  name: z.string(),
  templateId: z.string().optional(),
});

export type DataPointAnswerListRow = z.infer<
  typeof DataPointAnswerListRowSchema
>;

export const ListDataPointAnswersResponseSchema = z.object({
  data: z.array(DataPointAnswerListRowSchema),
  meta: z.object({
    count: z.number(),
    page: z.number(),
    pageSize: z.number(),
    totalCount: z.number(),
  }),
});

export type ListDataPointAnswersResponse = z.infer<
  typeof ListDataPointAnswersResponseSchema
>;
